module.exports = __webpack_public_path__ + "static/media/img-join-page.8da8fc1b.png";